
import getPlateCoords from './getPlateCoords';
import { useState, useMemo } from 'react';
import usePlateEditorDispatch from './usePlateEditorDispatch';
import PlateGrid from './PlateGrid';

const alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";


export default function PlateMapper({experiment,experimentId, gridId,dilutionTable,dispatch,mode}){

  const editorDispatch = usePlateEditorDispatch();
  let grid = experiment.grids[gridId];
  let rows = grid.length;
  let cols = grid[0].length;

  const [ hover, setHover ] = useState({gridId:null, pos:[-1,-1]});

  const hoverMap = useMemo(() => {

    if(mode !== "insert" ){
      return {};
    }

    if( (dilutionTable?.data?.length || 0) > 0 ){
    }

    let path = getPlateCoords(
      ...hover.pos,
      { rows, cols },
      dilutionTable?.data?.length || 0,
      dilutionTable.direction
    );

    let map = {};

    path.forEach(([r,c],ii) => {
      if( !map[r] ){ map[r] = {} }
      let curRow = map[r];

      curRow[c] = dilutionTable.data[ii]; 

    })



    return map;


  },[hover,mode])

  const onClick = (e,{row,col}) => {
    if( mode === "insert" ){
      dispatch({
        type:"setWellData",
        coordMap:hoverMap,
        gridId,
        experimentId
      })
    }else{

      editorDispatch({
        type:"click",
        event:e,
        args:{
          wells:[{
            gridId,
            row,
            col
          }]}
      })
    }

  }

  const [ showLabel, setShowLabel ] = useState(true);
  const [ showValue, setShowValue ] = useState(true);


  //well, substance0, substance1, ...

  let lines = [];

  let { variableMap } = experiment;
  let substanceIds = variableMap.map((x,ii) => x?ii:undefined).filter(x => !isNaN(x));
  let totalSubstances = substanceIds.length;


  grid.forEach((row,ii) => {
    row.forEach((well,jj) => {

      let wellId = alpha[ii]+(jj+1);

      let substances = {};

      well.forEach((liquid,ii) => {
        substances[ii] = {
          substance:variableMap[liquid.substance].substance,
          value:liquid.value,
          units:liquid.units
      }})

      let line = [ wellId ];



      for(let zz = 0; zz < totalSubstances; zz++){

        line.push( well[ substanceIds[zz] ]?.value || 0 )

      }


      lines.push(line)


    })
  })


  let linesStr = lines.map(rows => rows.join("\t"));



  return (
    <div>
      <div class="sg-row v-center" style={{marginLeft:20, marginBottom:5}}>


        <input type="checkbox" checked={showLabel} onChange={e => setShowLabel(e.target.checked)}/>
        Show label


        <input style={{marginLeft:10}} type="checkbox" checked={showValue} onChange={e => setShowValue(e.target.checked)}/> Show dose


      </div>


      <PlateGrid {...{
        grid,experiment, gridId, 
        setHover, hoverMap, onClick,
        showText:{
          label:showLabel,
          value:showValue,
        }
      }}/>



      {false && (
        <table>
          <tr>
            <td><b>Well</b></td>
            {substanceIds.map(id => {
              let liquidName = variableMap[id].substance;

              debugger;
             return <td><b>{liquidName}</b></td>
            })}
          </tr>
          {lines.map(line => {
            return (
              <tr>
                {line.map(data => {
                  return <td class="fair-padding">{data+""}</td>
                })}
              </tr>
            )
          })}

        </table>
      )}



    </div>
  )
}
